import { Skeleton } from 'primereact/skeleton';
import { ThemeContext } from '../../../theme/ThemeContext';
import { useContext } from 'react';

const AssessmentStatCard = ({
  title,
  value,
  icon,
  bgColor = "#fff",
  detailList = [],
  valueSuffix,
  loading = false,
}) => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";

  return (
    <div
      className="border-0 rounded-2 shadow"
      style={{
        height: "clamp(140px, 16vh, 150px)",
        minHeight: "clamp(140px, 16vh, 150px)",
        display: "flex",
        alignItems: "center",
        padding: "1rem 1.5rem",
        position: "relative",
        overflow: "hidden",
        backgroundColor: loading ? (isDark ? "#191919" : "#fff") : bgColor,
      }}
    >
      {loading ? (
        <div style={{ display: 'flex', width: '100%', alignItems: 'center', gap: '14px' }}>
          <Skeleton shape="circle" size="40px" />
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <Skeleton width="60%" height="30px" />
            <Skeleton width="40%" height="20px" />
          </div>
        </div>
      ) : (
        <div
          style={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            justifyContent: detailList.length > 0 ? "start" : "center",
          }}
        >
          {/* LEFT */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flexBasis: "40%",
              justifyContent: "center",
              textAlign: detailList.length > 0 ? "start" : "center",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", marginBottom: 6 }}>
              <img
                src={icon}
                alt={title}
                style={{
                  width: "clamp(30px, 2.5vw, 40px)",
                  height: "clamp(30px, 2.5vw, 40px)",
                  objectFit: "contain"
                }}
              />

              <span
                style={{
                  fontSize: "clamp(20px, 2.2vw, 30px)",
                  fontWeight: "bold",
                  color: "#222",
                  marginLeft: 14,
                }}
              >
                {value}
                {valueSuffix && (
                  <span style={{ fontSize: "clamp(12px, 1vw, 14px)", marginLeft: 2 }}>
                    {valueSuffix}
                  </span>
                )}
              </span>
            </div>

            <div
              className="text-dark"
              style={{
                fontSize: "clamp(13px, 1.1vw, 16px)",
                fontWeight: 600,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {title}
            </div>
          </div>

          {/* RIGHT */}
          {detailList.length > 0 && (
            <>
              <div
                style={{
                  background: "#c2cfd6",
                  width: 1,
                  height: "70%",
                  margin: "0 20px",
                  alignSelf: "center",
                }}
              />
              <div
                className="text-dark"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  flexBasis: "60%",
                }}
              >
                {detailList.map((d, i) => (
                  <span
                    key={i}
                    style={{
                      fontSize: "clamp(12px, 1vw, 14px)",
                      marginBottom: 7,
                    }}
                  >
                    {d.label}:{" "}
                    <b style={{ fontSize: "clamp(13px, 1.1vw, 16px)" }}>
                      {d.value}
                    </b>
                  </span>
                ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default AssessmentStatCard;